import { AssetListCardDetail, AssetType } from '../services/asset-service/types';
import { AssetFilters } from './types';

export const DEFAULT_FILTERS: AssetFilters = {
  search_text: '',
  asset_type: [],
  trust_status: [],
  access: [],
  sector: [],
  themes: [],
  regions: [],
};

export const DEFAULT_SORTED_ASSETS: Record<AssetType, AssetListCardDetail[]> = {
  Dataset: [],
  'AI Agent': [],
  'AI Tool': [],
  'AI Product': [],
};
